import * as yup from 'yup';

import { SortOrder } from '../sort';

const getQueryNumberPositiveArrayValue = (originalValue: unknown): number[] | undefined => {
  if (
    originalValue === undefined ||
    originalValue === null ||
    originalValue === '' ||
    (Array.isArray(originalValue) && originalValue.length === 0)
  ) {
    return undefined;
  }

  const values = Array.isArray(originalValue) ? originalValue : [originalValue];

  return values.map((value) => (typeof value === 'number' ? value : Number(value)));
};

const getQueryStringArrayValue = (originalValue: unknown): string[] | undefined => {
  if (
    originalValue === undefined ||
    originalValue === null ||
    originalValue === '' ||
    (Array.isArray(originalValue) && originalValue.length === 0)
  ) {
    return undefined;
  }

  const values = Array.isArray(originalValue) ? originalValue : [originalValue];

  const normalizedValues = values
    .flatMap((value) => String(value).split(','))
    .map((value) => value.trim())
    .filter(Boolean);

  return normalizedValues.length > 0 ? normalizedValues : undefined;
};

export const queryString = yup.string().transform((value, originalValue) => (originalValue ? value : undefined));
export const queryNumberPositive = yup.number().positive().transform((value, originalValue) => (originalValue ? value : undefined));
export const queryNumberPositiveArray = yup.mixed<number[]>().optional().transform((_, originalValue) => getQueryNumberPositiveArrayValue(originalValue))
  .test(
    'query-number-positive-array',
    '${path} must be a positive number array',
    (value) => value === undefined || value.every((item) => Number.isFinite(item) && item > 0),
  );
export const queryStringArray = yup.mixed<string[]>().optional().transform((_, originalValue) => getQueryStringArrayValue(originalValue));
export const queryPage = yup.number().integer().positive().default(undefined);
export const queryColumn = <Columns extends string>(keys: Columns[]) => yup.string<Columns>().oneOf(keys).default(undefined);
export const queryOrder = yup.string<SortOrder>().oneOf([SortOrder.Asc, SortOrder.Desc]).default(undefined);
export const queryOperator = <Operators extends string>(
  name: string,
  keys: Operators[],
) => yup.string<Operators>()
    .oneOf(keys).default(undefined)
    .when([name, '$isForURL'], ([value, isForURL], schema) => {
      if (isForURL !== true) {
        return schema;
      }
      return (
        value === undefined ||
        (typeof value === 'string' && value.trim() === '') ||
        (Array.isArray(value) && value.length === 0)
      )
        ? schema.transform(() => undefined)
        : schema;
    });
